import { useEffect, useRef } from 'react';
import * as S from './Navigation.style';
import { SidebarNavItem, SidebarNavItemsProps } from './NavigationItem';

type SidebarNavProps = {
  items: Array<SidebarNavItemsProps>;
  expanded?: boolean;
};

export const SidebarNav = ({
  items,
  expanded = false,
}: SidebarNavProps): JSX.Element => {
  const marker: any = useRef();

  const changeActiveMenuItem = (e: any) => {
    if (e !== null && marker.current) {
      marker.current.style.display = 'block';
      marker.current.style.top = `${e.closest('li')?.offsetTop}px`;
      marker.current.style.height = `${e.closest('li')?.offsetHeight}px`;
    }
  };

  useEffect(() => {
    changeActiveMenuItem(
      window.document.getElementById(window.location.pathname.replace('/', '')),
    );
  }, []);

  return (
    <S.Nav>
      <ul>
        {items.map((navItem, index) => (
          <SidebarNavItem
            active={navItem.active}
            name={navItem.name}
            key={`${navItem.id}-${index}`}
            id={navItem.id}
            goTo={navItem.goTo}
            link={navItem.link}
            Icon={navItem.Icon}
            expanded={expanded}
          />
        ))}
      </ul>
      <S.Line ref={marker} />
    </S.Nav>
  );
};
